import { __assign } from 'tslib';
import { card } from './card.js';
import { buttons } from './buttons.js';
import { iconButtons } from './icon-buttons.js';

var _a, _b;
var menuList = {
    base: __assign(__assign({}, card.base), { gridGap: 0, px: 0, py: 3, my: 3, width: "300px", maxWidth: "calc( 100vw - 32px )", backgroundColor: "white", boxShadow: 4, "--card-border-color": "var(--colors-black-10)" }),
    variants: {
        elevation: __assign({}, (_a = card.variants) === null || _a === void 0 ? void 0 : _a.elevation),
    },
};
var menuItem = {
    base: __assign(__assign({}, buttons.base), { width: "100%", overflow: "hidden", border: "none", borderRadius: 0, backgroundColor: "var(--menuItem-inactive-bgcolor)", color: "var(--menuItem-inactive-color)", outline: "none", fontWeight: "normal", justifyContent: "flex-start", svg: {
            color: "var(--menuItem-svg-inactive-color)",
        }, ":focus:not(:disabled):not([data-disabled='true']), &[data-selected='true']": {
            backgroundColor: "var(--menuItem-active-bgcolor)",
            color: "var(--menuItem-active-color)",
            svg: {
                color: "var(--menuItem-svg-active-color)",
            },
            boxShadow: "none",
        }, ":hover:not(:disabled):not([data-disabled='true'])": {
            boxShadow: "none",
        } }),
    variants: {
        tone: {
            primary: {
                "--menuItem-active-color": "var(--colors-primary-100)",
                "--menuItem-inactive-color": "var(--colors-black-100)",
                "--menuItem-svg-active-color": "var(--colors-primary-100)",
                "--menuItem-svg-inactive-color": "var(--colors-black-60)",
                "--menuItem-active-bgcolor": "var(--colors-primary-5)",
                "--menuItem-inactive-bgcolor": "var(--colors-white)",
            },
        },
        size: __assign({}, (_b = buttons.variants) === null || _b === void 0 ? void 0 : _b.size),
    },
    defaultProps: {
        size: "md",
        look: "",
        tone: "primary",
        rounded: false,
    },
};
var menuIconButton = {
    base: __assign(__assign({}, iconButtons.base), { "&[aria-expanded='false']": { color: "black.60" } }),
    variants: __assign({}, iconButtons.variants),
    defaultProps: __assign({}, iconButtons.defaultProps),
};

export { menuIconButton, menuItem, menuList };
//# sourceMappingURL=menu.js.map
